<!-- Loading spinner -->
<div class="loading" *ngIf="loading; else ready">
    <app-dot-loader-scale class="offers-loader-scale"></app-dot-loader-scale>
</div>

<ng-template #ready>
    <mat-tab-group
        mat-stretch-tabs="true"
        mat-align-tabs="start"
        [(selectedIndex)]="selectedIndex"
        animationDuration="0ms"
    >
        <!-- Details tab -->
        <mat-tab>
            <ng-template mat-tab-label>Details</ng-template>
            <!-- Each content section must be an ng-template to refresh on tab switch. -->
            <ng-template matTabContent>
                <div class="grid grid-flow-col grid-cols-[1fr_352px]">
                    <div
                        appDynamicScreenHeight
                        [dshdConfig]="{ scrollable: true }"
                        class="p-4"
                    >
                        <mat-card appearance="outlined">
                            <app-details
                                [applicationDetails]="
                                    applicationDetails$ | async
                                "
                                [applicationFields]="applicationFields$ | async"
                            >
                            </app-details>
                        </mat-card>
                    </div>

                    <!-- Deal sidebar -->
                    <app-deal-sidebar [dealId]="dealId"></app-deal-sidebar>
                </div>
            </ng-template>
        </mat-tab>

        <!-- Documents tab -->
        <mat-tab>
            <ng-template mat-tab-label>
                Documents
                <span
                    *ngIf="documents$ | async as documents"
                    class="!font-light !text-gray-400"
                    >&nbsp;{{ documents?.length }}</span
                >
            </ng-template>
            <ng-template matTabContent>
                <div class="grid grid-flow-col grid-cols-[1fr_352px]">
                    <div
                        appDynamicScreenHeight
                        [dshdConfig]="{ scrollable: true }"
                        class="p-4"
                    >
                        <mat-card appearance="outlined">
                            <app-documents-smart
                                [dealId]="dealId"
                                [borrowerLenderId]="businessLenderId$ | async"
                            ></app-documents-smart>
                        </mat-card>
                    </div>
                    <app-deal-sidebar [dealId]="dealId"></app-deal-sidebar>
                </div>
            </ng-template>
        </mat-tab>

        <!-- Offers tab -->
        <mat-tab>
            <ng-template mat-tab-label>
                Offers
                <span
                    *ngIf="offers$ | async as offers"
                    class="!font-light !text-gray-400"
                    >&nbsp;{{ offers?.length }}</span
                >
            </ng-template>
            <ng-template matTabContent>
                <div class="grid grid-flow-col grid-cols-[1fr_352px]">
                    <div
                        appDynamicScreenHeight
                        [dshdConfig]="{ scrollable: true }"
                        class="p-4"
                    >
                        <app-offers-smart
                            [dealId]="dealId"
                            [loanProductCategory]="loanProductCategory"
                        >
                        </app-offers-smart>
                    </div>

                    <app-deal-sidebar [dealId]="dealId"></app-deal-sidebar>
                </div>
            </ng-template>
        </mat-tab>

        <!-- Approvals tab -->
        <mat-tab>
            <ng-template mat-tab-label>
                Approvals
                <span
                    *ngIf="(approvals$ | async) as approvals"
                    class="!font-light !text-gray-400"
                    >&nbsp;{{ approvals?.length }}</span>
            </ng-template>
            <ng-template matTabContent>
                <div class="grid grid-flow-col grid-cols-[1fr_352px]">
                    <div
                        appDynamicScreenHeight
                        [dshdConfig]="{ scrollable: true }"
                    >
                        <app-approval-smart
                            [approvals]="approvals"
                            [dealId]="dealId"
                        ></app-approval-smart>
                    </div>
                    <app-deal-sidebar [dealId]="dealId"></app-deal-sidebar>
                </div>
            </ng-template>
        </mat-tab>

        <!-- Decisioning tab -->
        <mat-tab *ngIf="lpxCanViewDecisioningTab">
            <ng-template mat-tab-label>Decisioning</ng-template>
            <ng-template matTabContent>
                <div class="grid grid-flow-col grid-cols-[1fr_352px]">
                    <div
                        appDynamicScreenHeight
                        [dshdConfig]="{ scrollable: true }"
                    >
                        <app-decisioning
                            [borrowerId]="borrowerId"
                            [loanProductId]="loanProductId"
                        ></app-decisioning>
                    </div>
                    <app-deal-sidebar [dealId]="dealId"></app-deal-sidebar>
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</ng-template>
